"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOriflameUrl = isOriflameUrl;
/**
 * Checks if the provided URL belongs to any Oriflame domain
 * @param url - The URL string to check
 * @returns boolean - true if the URL belongs to any Oriflame domain, false otherwise
 */

const regex = /(?:\.|^)(?:oriflame\.(?:com|[a-z]{2})|ori-test\.(?:com|[a-z]{2})|online\.ori)$/i;
function isOriflameUrl(url) {
  try {
    const urlObject = new URL(url);
    const {
      hostname
    } = urlObject;
    return regex.test(hostname);
  } catch {
    // Return false if the URL is invalid
    return false;
  }
}
